import React, { useState, useEffect } from 'react';
import axios from "../../../../axios-order";
import { Snackbar, Alert } from '@mui/material';

function Fourteen({ handleBack, updateTableData, data, reasonsData, title, get_gstr9_report_data }) {
  const [reasonText, setReasonText] = useState('');
  // Initialize inputValues for all input fields
  const [inputValues, setInputValues] = useState(
    data?.map(item => ({
      taxable_and_non_taxable_manual: item.taxable_and_non_taxable_manual != null ? item.taxable_and_non_taxable_manual.toString() : '',
      amount_of_itc_total_manual: item.amount_of_itc_total_manual != null ? item.amount_of_itc_total_manual.toString() : '',
      amount_of_itc_eligible_manual: item.amount_of_itc_eligible_manual != null ? item.amount_of_itc_eligible_manual.toString() : '',
    })) || []
  );
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  useEffect(() => {
    console.log('Reasons data in useEffect:', JSON.stringify(reasonsData, null, 2));
    if (reasonsData && reasonsData.length > 0 && reasonsData[0].reasons) {
      setReasonText(reasonsData[0].reasons);
    } else {
      console.warn('No valid reasons data found. reasonText will remain empty.');
      setReasonText('');
    }
  }, [reasonsData]);

  const getAlphabeticSerial = (index) => {
    let result = '';
    let num = index;
    do {
      result = String.fromCharCode(65 + (num % 26)) + result;
      num = Math.floor(num / 26) - 1;
    } while (num >= 0);
    return result;
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSubmit = async () => {
    const reasons = reasonsData || [{}];
    const payload = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      gstr9c_recon_id: localStorage.getItem("gstr9c_recon_id"),
      records: {
        "14.Reconciliation of ITC declared in Annual Return (GSTR9) with ITC availed on expenses": data.map((item, index) => ({
          id: item.id,
          business_entity_id: item.business_entity_id,
          description: item.description,
          taxable_non_taxable_value: item.taxable_non_taxable_value || item.taxable_value || 0,
          central_tax: item.central_tax || 0,
          state_tax_ut_tax: item.state_tax_ut_tax || item.state_ut_tax || 0,
          integrated_tax: item.integrated_tax || 0,
          cess: item.cess || 0,
          amount_of_itc_total: item.amount_of_itc_total || null,
          amount_of_itc_eligible: item.amount_of_itc_eligible || null,
          taxable_and_non_taxable_manual: inputValues[index].taxable_and_non_taxable_manual === '' ? null : parseFloat(inputValues[index].taxable_and_non_taxable_manual),
          amount_of_itc_total_manual: inputValues[index].amount_of_itc_total_manual === '' ? null : parseFloat(inputValues[index].amount_of_itc_total_manual),
          amount_of_itc_eligible_manual: inputValues[index].amount_of_itc_eligible_manual === '' ? null : parseFloat(inputValues[index].amount_of_itc_eligible_manual),
        })),
        "15.Reasons for Un - Reconciled difference in ITC": [
          {
            description: reasons[0]?.description || "Reasons for Un - Reconciled difference in ITC",
            reasons: reasonText === '' ? null : reasonText
          }
        ]
      }
    };

    try {
      const response = await axios.post("/gstr9c_manual_data_update", payload);
      console.log('Submit response:', response.data);
      if (response.data.status === true) {
        setSnackbar({
          open: true,
          message: response.data.message || 'Values updated successfully.',
          severity: 'success',
        });
        if (typeof get_gstr9_report_data === 'function') {
          await get_gstr9_report_data();
        } else {
          console.warn('get_gstr9_report_data is not a function');
        }
      } else {
        setSnackbar({
          open: true,
          message: response.data.message || 'Failed to update values.',
          severity: 'error',
        });
      }
    } catch (error) {
      console.error('Error submitting data:', error);
      setSnackbar({
        open: true,
        message: 'An error occurred while submitting data.',
        severity: 'error',
      });
    }
  };

  const handleManualInputChange = (index, field, value) => {
    const numericValue = value.replace('₹', '').trim();
    if (numericValue !== '' && !/^-?\d*\.?\d*$/.test(numericValue)) {
      alert('Please enter a valid number (digits, optional negative sign, and optional decimal point).');
      return;
    }
    const newInputValues = [...inputValues];
    newInputValues[index] = { ...newInputValues[index], [field]: numericValue };
    setInputValues(newInputValues);
    const newData = [...data];
    const parsedValue = numericValue === '' ? null : parseFloat(numericValue);
    newData[index] = { ...newData[index], [field]: parsedValue };
    if (typeof updateTableData === 'function') {
      updateTableData(newData);
    } else {
      console.warn('updateTableData is not a function. Data update skipped.');
    }
  };

  // Handle key press to allow digits, negative sign, decimal point
  const handleKeyDown = (e, index) => {
    if (index === 15 || index === 17) {
      e.preventDefault();
      console.log(`Keypress blocked for index ${index} (P or R)`);
      return;
    }
    const allowedKeys = [
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab',
      '-', '.'
    ];
    const input = e.target.value.replace('₹', '').trim();

    // Prevent multiple decimal points
    if (e.key === '.' && input.includes('.')) {
      e.preventDefault();
      return;
    }

    // Prevent multiple negative signs or negative sign not at start
    if (e.key === '-') {
      const cursorPosition = e.target.selectionStart;
      // Allow minus only at position 1 (after ₹) if there's no minus already
      if (input.includes('-') || cursorPosition !== 1) {
        e.preventDefault();
        return;
      }
    }

    // Limit decimal places to 2
    if (e.key >= '0' && e.key <= '9') {
      const parts = input.split('.');
      if (parts.length === 2 && parts[1].length >= 2) {
        // Check if cursor is after the decimal point
        const cursorPosition = e.target.selectionStart;
        const fullValue = e.target.value;
        const decimalPosition = fullValue.indexOf('.');
        // If there's text selected, allow replacement
        if (e.target.selectionStart === e.target.selectionEnd && cursorPosition > decimalPosition) {
          e.preventDefault();
          return;
        }
      }
    }

    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  // const handleKeyDown = (e) => {
  //   const allowedKeys = [
  //     '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  //     'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab',
  //     '-', '.'
  //   ];
  //   const input = e.target.value.replace('₹', '');

  //   if (e.key === '.' && input.includes('.')) {
  //     e.preventDefault();
  //     return;
  //   }

  //   if (e.key === '-' && (input.includes('-') || e.target.selectionStart !== 0)) {
  //     e.preventDefault();
  //     return;
  //   }

  //   if (!allowedKeys.includes(e.key)) {
  //     e.preventDefault();
  //   }
  // };

  console.log('Fourteen component data:', JSON.stringify(data, null, 2));

  const getRowColor = (index) => {
    const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
    return colors[index % colors.length];
  };

  // Define descriptions to hide Value and Total ITC columns
  const hiddenColumnsDescriptions = [
    'R.Total amount of eligible ITC availed (A to Qn)*',
    'S.ITC claimed in Annual Return (GSTR9)',
    'T.Un-reconciled ITC (S-R)*'
  ];

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '30px',
        width: '100%',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        boxSizing: 'border-box'
      }}>
        <button
          onClick={handleBack}
          style={{
            marginBottom: '20px',
            padding: '8px 16px',
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '12px',
            color: '#64748b'
          }}
        >
          Back
        </button>

        <h2 style={{
          marginBottom: '20px',
          color: '#1e293b',
          fontSize: '20px',
          fontWeight: '700',
          textAlign: 'center'
        }}>
          {title || 'Table 14 - Reconciliation of ITC Declared in Annual Return (GSTR9) with ITC Availed on Expenses'}
        </h2>

        {/* Table Header */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '60px 3fr 1fr 1fr 1fr 1fr 1fr 1fr',
          gap: '8px',
          fontWeight: '600',
          color: '#475569',
          padding: '15px 10px',
          borderBottom: '2px solid #e2e8f0',
          fontSize: '14px',
          backgroundColor: '#f8fafc',
          borderRadius: '8px',
          marginBottom: '10px',
          position: 'sticky',
          top: 0,
          zIndex: 1,
          boxSizing: 'border-box',
          width: '100%'
        }}>
          <span style={{ textAlign: 'center' }}>S.No.</span>
          <span>Description</span>
          <span style={{ textAlign: 'center' }}>Value (₹)</span>
          <span style={{ textAlign: 'center' }}>Total ITC (₹)</span>
          <span style={{ textAlign: 'center' }}>Eligible ITC (₹)</span>
          <span style={{ textAlign: 'center' }}>Manual Value (₹)</span>
          <span style={{ textAlign: 'center' }}>Manual Total ITC (₹)</span>
          <span style={{ textAlign: 'center' }}>Manual Eligible ITC (₹)</span>
        </div>

        <div style={{
          maxHeight: 'calc(100vh - 450px)',
          overflowY: 'auto',
          marginTop: '10px',
          scrollbarWidth: 'thin',
          scrollbarColor: '#64748b #f1f5f9',
          width: '100%'
        }}>
          <style>
            {`
      div::-webkit-scrollbar {
        width: 12px;
      }
      div::-webkit-scrollbar-track {
        background: #f1f5f9;
        borderRadius: 6px;
      }
      div::-webkit-scrollbar-thumb {
        background: #64748b;
        borderRadius: 6px;
      }
      div::-webkit-scrollbar-thumb:hover {
        background: #475569;
      }
    `}
          </style>
          {data && Array.isArray(data) && data.length > 0 ? (
            data.map((item, index) => (
              <div key={index} style={{
                display: 'grid',
                gridTemplateColumns: '60px 3fr 1fr 1fr 1fr 1fr 1fr 1fr',
                gap: '8px',
                alignItems: 'center',
                padding: '10px',
                borderBottom: '1px solid #f1f5f9',
                backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
                borderRadius: '6px',
                marginBottom: '2px',
                minHeight: '40px',
                boxSizing: 'border-box',
                width: '100%'
              }}>
                <span style={{
                  color: '#1e293b',
                  fontSize: '13px',
                  fontWeight: '600',
                  textAlign: 'center',
                  padding: '6px',
                  backgroundColor: getRowColor(index),
                  borderRadius: '6px',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                   {index + 1}
                </span>
                <span style={{
                  color: '#334155',
                  fontSize: '13px',
                  padding: '6px 10px',
                  backgroundColor: '#f1f5f9',
                  borderRadius: '6px',
                  wordBreak: 'break-word',
                  minWidth: '0',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  {item.description || 'N/A'}
                </span>
                <span style={{
                  color: '#1e293b',
                  fontWeight: '500',
                  fontSize: '13px',
                  textAlign: 'right',
                  padding: '6px',
                  backgroundColor: '#ecfdf5',
                  borderRadius: '6px',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end'
                }}>
                  {hiddenColumnsDescriptions.includes(item.description) ? '' : `₹${item.taxable_non_taxable_value?.toLocaleString() || '0'}`}
                </span>
                <span style={{
                  color: '#1e293b',
                  fontWeight: '500',
                  fontSize: '13px',
                  textAlign: 'right',
                  padding: '6px',
                  backgroundColor: '#fef3c7',
                  borderRadius: '6px',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end'
                }}>
                  {hiddenColumnsDescriptions.includes(item.description) ? '' : `₹${item.amount_of_itc_total?.toLocaleString() || '0'}`}
                </span>
                <span style={{
                  color: '#1e293b',
                  fontWeight: '500',
                  fontSize: '13px',
                  textAlign: 'right',
                  padding: '6px',
                  backgroundColor: '#dbeafe',
                  borderRadius: '6px',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end'
                }}>
                  ₹{item.amount_of_itc_eligible?.toLocaleString() || '0'}
                </span>
                <input
                  type="text"
                  value={`₹${inputValues[index].taxable_and_non_taxable_manual ?? '0'}`}
                  onChange={(e) => handleManualInputChange(index, 'taxable_and_non_taxable_manual', e.target.value)}
                  onKeyDown={handleKeyDown}
                  style={{
                    color: '#1e293b',
                    fontWeight: '500',
                    fontSize: '13px',
                    textAlign: 'right',
                    padding: '6px',
                    backgroundColor: '#ecfdf5',
                    border: '1px solid #e2e8f0',
                    borderRadius: '6px',
                    width: '100%',
                    outline: 'none',
                    boxSizing: 'border-box',
                    minHeight: '28px'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#88d8a3';
                    e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
                    const value = e.target.value.replace('₹', '');
                    e.target.setSelectionRange(0, value.length);
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                    handleManualInputChange(index, 'taxable_and_non_taxable_manual', e.target.value);
                  }}
                />
                <input
                  type="text"
                  value={`₹${inputValues[index].amount_of_itc_total_manual ?? '0'}`}
                  onChange={(e) => handleManualInputChange(index, 'amount_of_itc_total_manual', e.target.value)}
                  onKeyDown={handleKeyDown}
                  style={{
                    color: '#1e293b',
                    fontWeight: '500',
                    fontSize: '13px',
                    textAlign: 'right',
                    padding: '6px',
                    backgroundColor: '#fef3c7',
                    border: '1px solid #e2e8f0',
                    borderRadius: '6px',
                    width: '100%',
                    outline: 'none',
                    boxSizing: 'border-box',
                    minHeight: '28px'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#88d8a3';
                    e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
                    const value = e.target.value.replace('₹', '');
                    e.target.setSelectionRange(0, value.length);
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                    handleManualInputChange(index, 'amount_of_itc_total_manual', e.target.value);
                  }}
                />
                <input
                  type="text"
                  value={`₹${inputValues[index].amount_of_itc_eligible_manual ?? '0'}`}
                  onChange={(e) => handleManualInputChange(index, 'amount_of_itc_eligible_manual', e.target.value)}
                  onKeyDown={handleKeyDown}
                  style={{
                    color: '#1e293b',
                    fontWeight: '500',
                    fontSize: '13px',
                    textAlign: 'right',
                    padding: '6px',
                    backgroundColor: '#dbeafe',
                    border: '1px solid #e2e8f0',
                    borderRadius: '6px',
                    width: '100%',
                    outline: 'none',
                    boxSizing: 'border-box',
                    minHeight: '28px'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#88d8a3';
                    e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
                    const value = e.target.value.replace('₹', '');
                    e.target.setSelectionRange(0, value.length);
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                    handleManualInputChange(index, 'amount_of_itc_eligible_manual', e.target.value);
                  }}
                />
              </div>
            ))
          ) : (
            <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
              No data available for this section.
            </div>
          )}
        </div>
        {/* Banner with Input and Submit Button */}
        <div style={{
          marginTop: '30px',
          display: 'flex',
          alignItems: 'center',
          height: '80px',
          gap: '0'
        }}>
          <div style={{
            position: 'relative',
            width: '50%',
            height: '40px',
            background: 'linear-gradient(135deg, rgb(187, 63, 25) 0%, rgb(157, 58, 58) 50%, rgb(127, 205, 205) 100%)',
            clipPath: 'polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 25px rgba(168, 230, 207, 0.3)',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute',
              top: 0,
              right: '10px',
              width: '40px',
              height: '100%',
              background: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\'%3E%3Cdefs%3E%3Cpattern id=\'pattern2\' x=\'0\' y=\'0\' width=\'15\' height=\'15\' patternUnits=\'userSpaceOnUse\'%3E%3Ccircle cx=\'7.5\' cy=\'7.5\' r=\'1.5\' fill=\'rgba(255,255,255,0.1)\'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width=\'100\' height=\'100\' fill=\'url(%23pattern2)\'/%3E%3C/svg%3E")',
              zIndex: 1
            }}></div>
            <div style={{
              fontSize: '16px',
              fontWeight: 'bold',
              color: 'white',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
              zIndex: 2,
              position: 'relative',
              marginRight: '20px',
              textAlign: 'center',
              maxWidth: '80%'
            }}>
              15. Reasons for Un - Reconciled difference in ITC
            </div>
          </div>
          <div style={{
            width: '50%',
            height: '80px',
            display: 'flex',
            alignItems: 'center',
            padding: '0 20px',
            backgroundColor: '#f8fafc',
            border: '2px solid #e2e8f0',
            borderLeft: 'none',
            gap: '10px'
          }}>
            <textarea
              value={reasonText}
              onChange={(e) => setReasonText(e.target.value)}
              placeholder="Enter additional notes or remarks..."
              style={{
                flex: 1,
                padding: '10px 15px',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                fontSize: '14px',
                fontFamily: 'Arial, sans-serif',
                backgroundColor: 'white',
                outline: 'none',
                resize: 'none',
                height: '60px'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#88d8a3';
                e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.boxShadow = 'none';
              }}
            />
            <button
              onClick={handleSubmit}
              style={{
                padding: '10px 20px',
                background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
                transition: 'all 0.2s ease',
                minWidth: '80px'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 6px 16px rgba(255, 211, 165, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(255, 211, 165, 0.3)';
              }}
            >
              Submit
            </button>
          </div>
        </div>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
}

export default Fourteen;